import styled, { css } from 'styled-components';

/**
 * One saved card. The default card is outlined in the brand red so which one
 * gets charged first reads at a glance; the backup row is a button, since
 * clicking it makes it the default.
 */
export const CardRow = styled.div<{ $default?: boolean; $clickable?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 14px;
  background: ${({ theme }) => theme.white};
  border: 1px solid
    ${({ $default, theme }) => ($default ? theme.primary : theme.mediumGray)};
  transition: ${({ theme }) => theme.transitions.ease200ms};

  ${({ $clickable, theme }) =>
    $clickable &&
    css`
      cursor: pointer;

      :hover {
        box-shadow: ${theme.shadows.shadow2};
      }
    `}
`;

/** The brand logo on a vDrive-blue tile. */
export const BrandTile = styled.div`
  flex: none;
  width: 48px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.darkBlue};
`;

export const DefaultPill = styled.span`
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  color: ${({ theme }) => theme.darkGray};
  background: ${({ theme }) => theme.gray};
`;

/** The pencil and the bin: round icons that act on their own. */
export const RowAction = styled.button`
  flex: none;
  display: inline-flex;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  svg {
    width: 30px;
    height: 30px;
  }
`;
